import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  container: {
    marginTop: "30px",
    marginBottom: "30px"
  },
  wrapKatalog: {
    marginTop: 20,
  },
  wrapCarousel:{
    paddingTop:"60px",
  },
  carousel: {
    marginTop: "0",
  },
  hero: {
    height: "300px",
    objectFit: "cover",
    width: "100%",
    // backgroundImage: linear - gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7))
  },
  wrapLeaderboard: {
    width: "100%",
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    padding: "20px",
  },
  small: {
    width: 40,
    height: 40,
    border: "2px solid #cd7f32"
  },
  medium: {
    width: 60,
    height: 60,
    border: "2px solid #5675D3"
  },
  large: {
    width: 80,
    height: 80,
    border: "2px solid #F9A23D"
  },
  colorGold: {
    color: "#FFFFFF",
    backgroundColor: "#F9A23D"
  },
  colorBronze: {
    color: "#FFFFFF",
    backgroundColor: "#cd7f32"
  },
  wrapKategori: {
    padding: "10px",
  },
  kategori: {
    marginTop: 4,
    marginRight: 4,
    justifyContent: "flex-start",
    alignItems: "center",
  },
  iconKategori: {
    display: "flex",
    justifyContent: "center"
  },
  textKategori: {
    textAlign: "center"
  },
  iconBrand: {
    width: "50px"
  },
  banner: {
    objectFit: "cover",
    width: "100%",
    borderRadius: "10px"
  },
  card: {
    height: "100%",
    borderRadius: "10px",
    boxShadow: "0px 0px 8px rgba(0,0,0,0.2)",
  },
}))

export default useStyles
